
const digest = 'ea71a159fcf8a62cb89cadd923bbc2e5375d55ff7854589752277ea4feb2efee';
const classes = {"button":"_button_tbqb1_1","clickable":"_clickable_tbqb1_12","icon":"_icon_tbqb1_15","content":"_content_tbqb1_21","title":"_title_tbqb1_26","subtitle":"_subtitle_tbqb1_31","arrow":"_arrow_tbqb1_36","badge":"_badge_tbqb1_51","green":"_green_tbqb1_64"};
const css = `._button_tbqb1_1 {
  position: relative;
  text-decoration: none;
  background-color: #fff;
  padding: 13px 14px;
  display: flex;
  flex-direction: row;
  border-radius: 15px;
  align-items: center;
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
}
._button_tbqb1_1._clickable_tbqb1_12 {
  cursor: pointer;
}
._button_tbqb1_1 ._icon_tbqb1_15 {
  height: 50px;
  width: 50px;
  border-radius: 100%;
  margin-right: 14px;
}
._button_tbqb1_1 ._content_tbqb1_21 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
._button_tbqb1_1 ._content_tbqb1_21 ._title_tbqb1_26 {
  font-weight: 600;
  font-size: 16px;
  color: #3c3f9c;
}
._button_tbqb1_1 ._content_tbqb1_21 ._subtitle_tbqb1_31 {
  font-weight: 400;
  font-size: 14px;
  color: #212357;
}
._button_tbqb1_1 ._arrow_tbqb1_36 {
  height: 50px;
  width: 50px;
  min-width: 50px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e5f3ff;
  background: linear-gradient(0deg, #e5f3ff 0, #f4faff 100%);
  position: relative;
}
._button_tbqb1_1 ._arrow_tbqb1_36 img {
  height: 15px;
}
._button_tbqb1_1 ._badge_tbqb1_51 {
  position: absolute;
  background: rgb(255, 61, 5);
  background: linear-gradient(90deg, rgb(250, 177, 69) 0%, rgb(247, 155, 20) 80%, rgb(255, 61, 5) 100%);
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 10px;
  color: #ffffff;
  font-weight: 600;
  top: -10px;
  left: 20px;
}

._green_tbqb1_64 {
  background: #5cd9a6;
  background: linear-gradient(0deg, #209d92 0, #5cd9a6 100%);
}
._green_tbqb1_64 ._content_tbqb1_21 ._title_tbqb1_26 {
  color: #ffffff;
}
._green_tbqb1_64 ._content_tbqb1_21 ._subtitle_tbqb1_31 {
  color: #ffffff;
}
._green_tbqb1_64 ._arrow_tbqb1_36 {
  background: #24b2a2;
  box-shadow: inset 0px 3px 6px 4px rgba(0, 0, 0, 0.2);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  